import { render, staticRenderFns } from "./LegalReminderComp.vue?vue&type=template&id=44e299d1&scoped=true"
import script from "./LegalReminderComp.vue?vue&type=script&lang=js"
export * from "./LegalReminderComp.vue?vue&type=script&lang=js"
import style0 from "./LegalReminderComp.vue?vue&type=style&index=0&id=44e299d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e299d1",
  null
  
)

export default component.exports